// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PressContent__pressContainer___3TJKA{padding:0 24px 128px}.PressContent__inner___2fTSd{display:grid;grid-template-columns:repeat(4,1fr);grid-column-gap:40px;-moz-column-gap:40px;column-gap:40px}.PressContent__sidebar___r1hlg{display:none}@media (min-width:960px){.PressContent__sidebar___r1hlg{display:block;grid-column:1;padding-top:128px}}.PressContent__listContainer___9qMp5{grid-column:1/5}@media (min-width:960px){.PressContent__listContainer___9qMp5{grid-column:2/5}}.PressContent__pressList___1kNS3{padding-top:128px}.PressContent__pressList___1kNS3:first-child{margin-top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"pressContainer": "PressContent__pressContainer___3TJKA",
	"inner": "PressContent__inner___2fTSd",
	"sidebar": "PressContent__sidebar___r1hlg",
	"listContainer": "PressContent__listContainer___9qMp5",
	"pressList": "PressContent__pressList___1kNS3"
};
module.exports = ___CSS_LOADER_EXPORT___;
